// extracted by mini-css-extract-plugin
export var root = "_9x8H";
export var rootActive = "SiP0";
export var rootCategory = "_7Qw0";
export var rootDate = "vBdS";
export var rootHeader = "EhcH";
export var rootHeading = "_9QPm";
export var rootImage = "oJYV";
export var rootLink = "SWka";
export var rootPicture = "pzs+";
export var rootText = "p+wi";